import React from "react";
import { FaQuoteLeft, FaUserTie } from "react-icons/fa";
const PrincipalMessage = () => {
  return (
    <section className="relative py-20 px-4 md:px-8 bg-gradient-to-br from-orange-50 via-white to-red-50 overflow-hidden">
      <div className="absolute top-0 left-0 w-72 h-72 bg-orange-300/20 rounded-full blur-3xl -translate-x-24"></div>
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-red-300/20 rounded-full blur-3xl translate-x-24"></div>
      <div className="relative max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-5 py-2 text-sm font-semibold text-red-600 bg-red-100 rounded-full mb-4">
            Principal’s Message
          </span>
          <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900">
            From The{" "}
            <span className="bg-gradient-to-r from-red-600 to-orange-500 bg-clip-text text-transparent">
              Principal’s Desk
            </span>
          </h2>
          <p className="text-gray-600 mt-4 max-w-2xl mx-auto leading-7">
            Inspiring students to learn, grow and succeed with values and knowledge.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-[0.9fr_1.1fr] gap-8 items-center">
          <div className="bg-gradient-to-br from-red-600 to-orange-500 rounded-[32px] p-7 md:p-9 text-white shadow-2xl h-fit">
            <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center text-3xl mb-6">
              <FaQuoteLeft />
            </div>
            <h3 className="text-3xl md:text-4xl font-extrabold leading-tight mb-5">
              Education Builds Character & Confidence
            </h3>
            <p className="text-white/90 text-sm md:text-base leading-8 mb-6">
              Our aim is to provide a nurturing environment where every child feels valued, confident and motivated to achieve excellence.
            </p>
            <div className="space-y-3">
              <div className="bg-white/15 border border-white/20 rounded-2xl p-4 text-sm font-semibold">
                Value-based learning
              </div>
              <div className="bg-white/15 border border-white/20 rounded-2xl p-4 text-sm font-semibold">
                Focus on discipline & growth
              </div>
              <div className="bg-white/15 border border-white/20 rounded-2xl p-4 text-sm font-semibold">
                Safe & positive environment
              </div>
            </div>
          </div>
          <div className="bg-white rounded-[32px] shadow-xl border border-orange-100 p-7 md:p-9">
            <p className="text-gray-700 text-sm md:text-[15px] leading-8 text-justify mb-5">
              At Asha Modern School, we believe that education is not just about academics, but about shaping the overall personality of a child. Our goal is to create responsible, confident and compassionate individuals.
            </p>
            <p className="text-gray-600 text-sm md:text-[15px] leading-8 text-justify mb-5">
              We focus on a balanced approach where students are encouraged to explore their talents, develop critical thinking and build strong moral values along with modern education.
            </p>
            <p className="text-gray-600 text-sm md:text-[15px] leading-8 text-justify">
              With the support of dedicated teachers and a positive environment, we ensure that every child grows with confidence and is prepared for future challenges.
            </p>
            <div className="mt-8 pt-5 border-t border-gray-200 flex items-center gap-4">
              <div className="w-12 h-12 rounded-full bg-gradient-to-r from-red-600 to-orange-500 text-white flex items-center justify-center text-lg">
                <FaUserTie />
              </div>
              <div>
                <h4 className="text-lg font-bold text-gray-900">
                  Principal Name
                </h4>
                <p className="text-sm text-red-600 font-semibold">
                  Principal, Asha Modern School
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrincipalMessage;